// extracted by mini-css-extract-plugin
export default {"blockly":"_3OHXCHTs4AS-BnFEW9C9QA"};